/**
 * @module manifest/panelLayout/simpleCharts
 * @description Config A：饼图 / 地图 / 词云 / 组合图面板布局
 */

import { ChartType, type TChartType } from '@dbl/core/chart';
import { type PanelTabLayout } from './types';

const pieBasicGroups = [
  'LegendColorSetting',
  'XAxisSetting',
  'LegendSetting',
] as const;

const mapBasicGroups = ['DataLabel', 'MapColorSelector'] as const;

const wordCloudBasicGroups = ['ColorSetting', 'CountLimit'] as const;

const mixedChartLayout: PanelTabLayout[] = [
  {
    id: 'basic',
    groups: [
      'DataLabel',
      'LegendColorSetting',
      'XAxisSetting',
      'LegendSetting',
      'ToolTipSetting',
    ],
  },
  { id: 'yAxis', groups: ['MixedAxisConfig'] },
];

export const SIMPLE_CHART_PANEL_LAYOUT: Partial<
  Record<TChartType, PanelTabLayout[]>
> = {
  [ChartType.Pie]: [{ id: 'basic', groups: pieBasicGroups }],
  [ChartType.Map]: [{ id: 'basic', groups: mapBasicGroups }],
  [ChartType.WordCloud]: [{ id: 'basic', groups: wordCloudBasicGroups }],
  [ChartType.MixedChart]: mixedChartLayout,
};

